import { SharedState } from '@trello/shared-state';

export const activeListIdSharedState = new SharedState<string>('');
